import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from "@angular/core";
import {LocaleSwitcherService} from "../locale-switcher.service";
import {IShopUser} from "../../session/customer-models";
import {ILocaleProperties, LocaleType} from "../locale-models";
import * as _ from 'lodash';
import {LoggerService} from "../../common/logger.service";
import {UserService} from "../../common/user.service";
import {BaseComponent} from "../../base.component";
import {forkJoin, of} from "rxjs";
import {map, switchMap} from "rxjs/operators";

@Component({
    selector: 'locale-list',
    templateUrl: './locale-list.component.html',
    styleUrls: ['./locale-list.component.scss'],
    standalone: false
})
export class LocaleListComponent extends BaseComponent implements OnInit, OnChanges {

    @Input() search: string;
    @Input() onSelectLocale: ILocaleProperties;
    @Input() autoSelectUserLocale: boolean;
    @Input() localeListClass: string;
    @Input() localeType: LocaleType = LocaleType.RETAIL;

    @Output() readonly currentLocaleData = new EventEmitter();
    @Output() readonly localeEvent: EventEmitter<ILocaleProperties> = new EventEmitter<ILocaleProperties>();

    continents: ILocaleProperties[][];
    selectedLocale: ILocaleProperties;

    constructor(
        private userService: UserService,
        private localeSwitcherService: LocaleSwitcherService,
        loggerService: LoggerService,
    ) {
        super(userService, loggerService);
    }

    ngOnInit() {
        this.setupLocalesForSwitcher().subscribe((continentLocales: ILocaleProperties[][]) => {
            this.continents = continentLocales;
            this.log.debug('Setup locales for switcher', this.continents);
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if(changes.onSelectLocale?.currentValue) {
            this.selectLocale(changes.onSelectLocale.currentValue);
        }
    }

    setupLocalesForSwitcher() {
        return this.localeSwitcherService.getLocalesForSwitcher(this.localeType).pipe(
            switchMap((locales: ILocaleProperties[]) => {
                return forkJoin(locales.map((locale: ILocaleProperties) => {
                    return of(locale);
                }));
            }),
            map((locales: ILocaleProperties[]) => {
                this.localeSwitcherService.localePropertiesSubject.next(locales);
                this.userService.getShopUserPromise().then((user: IShopUser) => {
                    const currentLocale = _.find(locales, (localeData: ILocaleProperties) => localeData.usanaLocale === user.usanaLocale);
                    if (currentLocale) {
                        this.currentLocaleData.emit(currentLocale);
                    }
                    if (this.autoSelectUserLocale) {
                        this.selectedLocale = currentLocale;
                    }
                });
                const continentNames = _.map(_.uniqBy(locales, 'continent'), 'continent');
                return _.map(continentNames, (continent) => _.filter(locales, locale => locale.continent === continent));
            }),
        );
    }

    selectLocale(locale: ILocaleProperties) {
        this.selectedLocale = locale;
        this.localeEvent.emit(locale);
    }

    isSelectedLocale(locale: ILocaleProperties): boolean {
        return this.selectedLocale?.country == locale.country && this.selectedLocale?.language == locale.language;
    }
}
